export default "__VITE_ASSET__6jOzoV5d__"